import { createFeatureSelector, createSelector } from '@ngrx/store';

import { selectCampaignContext } from 'app/_state/campaign-context/campaign-context-selectors';
import { selectQueryParams, selectUrl } from 'app/_state/router/router-selectors';
import { EntityGeoJSONFeatureFactory } from 'app/map/helpers/entity-geojson-feature-factory';
import {
  EntityMarkerFeatureMakerForConnections
} from 'app/map/helpers/EntityMarkerFeatureMakerForConnections';

import { EntityMapViewState, StateName } from './entity-map-view.state';
import { removeUnmappableAddresses } from 'app/map/helpers/remove-unmappable-addresses';

export const selectEntityMapViewContext = createFeatureSelector<EntityMapViewState>(StateName);
export const currentCampaignContext = selectCampaignContext;

export const SELECT_MAP_POSITION = createSelector(selectEntityMapViewContext, (state) => state.mapPosition);

export const SELECT_IS_DATA_LOADING = createSelector(selectEntityMapViewContext, (state) => state.dataLoading);

export const SELECT_COUNT = createSelector(selectEntityMapViewContext, (state) => state?.queryResult?.entitiesQuery?.limitedCount);

export const SELECT_ENTITY_RESULT_NODES = createSelector(
  selectEntityMapViewContext, (state) => state.queryResult?.entitiesQuery?.nodes || []
);

export const SELECT_MAP_ACCURACY_NOTICE_VISIBLE = createSelector(
  selectEntityMapViewContext,
  (state) =>
    state.queryResult?.entitiesQuery?.nodes?.some((node) =>
      node.addresses.some((address) => address.accuracyType === "postcode")
    )
);

export const SELECT_VISIBLE_LAYER_OPTION = createSelector(selectQueryParams, (qparams) => qparams.layer === 'all' ? 'all' : 'best');

export const SELECT_VISIBLE_GEOJSON_LAYER = createSelector(
  SELECT_ENTITY_RESULT_NODES,
  SELECT_VISIBLE_LAYER_OPTION,
  selectCampaignContext, (nodes, layer, campaignContext) => {
    if (!campaignContext.current_campaign) {
      return null;
    }

    const featureMaker = new EntityGeoJSONFeatureFactory(
      new EntityMarkerFeatureMakerForConnections(
        campaignContext.current_campaign.defaultEntityType?.id,
        (entity: any) => removeUnmappableAddresses(entity.addresses)
      )
    );
    if (layer === 'best') {
      return featureMaker.createBestAddressLayer(nodes);
    } else {
      return featureMaker.createAllAddressesLayer(nodes);
    }
  });

export const SELECT_CURRENT_QUERY = createSelector(selectEntityMapViewContext, (state) => state.currentQuery);

export const SELECT_URL_AND_PARAMS = createSelector(selectUrl, selectQueryParams, (
  (url, queryParams) => ({ url, queryParams })
)
);

export const SELECT_SELECTED_MARKER = createSelector(selectEntityMapViewContext, (state) => state.selectedMarker);
